export default "__VITE_ASSET__B2hXCo7z__"